var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.57 1.082c-.273.273-.246.684 0 .957l3.31 3.117H1.03a.648.648 0 0 0-.656.657v.875c0 .382.273.656.656.656h7.85l-3.31 3.144a.713.713 0 0 0 0 .957l.602.602c.273.246.683.246.93 0l5.332-5.332c.246-.246.246-.656 0-.93L7.102.48c-.247-.246-.657-.246-.93 0l-.602.602z","fill":"#1565D8","key":0}),React.createElement("path",{"d":"M5.57 1.082c-.273.273-.246.684 0 .957l3.31 3.117H1.03a.648.648 0 0 0-.656.657v.875c0 .382.273.656.656.656h7.85l-3.31 3.144a.713.713 0 0 0 0 .957l.602.602c.273.246.683.246.93 0l5.332-5.332c.246-.246.246-.656 0-.93L7.102.48c-.247-.246-.657-.246-.93 0l-.602.602z","fill":"#fff","key":1})]);
}

ArrowRightInline.defaultProps = {"viewBox":"0 0 13 13","width":"13","height":"13","fill":"none"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
